<template>
  <div class="search-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-row'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <input class="form-control" type="text"
          :id="options.name"
          :value="value"
          @input="validate($event.target.value)"
          :name="options.name"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'SearchInput',
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      isLength: true,
      minLength: 1
    }
  },
  mounted () {
    this.validate(this.value)
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (this.options.required) {
        this.isDirty = true
        this.isLength = this.isValid = val.length >= this.minLength
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/SearchInput.vue